module.exports = __webpack_public_path__ + "static/media/Artboard3.cd8f961c.png";